import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface CustomSvgIconProps extends SvgIconProps {
  hideVector?: boolean;
}

export const SwitchThumbVectorIconOn = ({
  hideVector,
  ...props
}: CustomSvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="100%" height="100%" rx="50%" fill="white" />
    {!hideVector && (
      <g>
        <path
          d="M8.99997 13.78L6.68664 11.4667C6.42664 11.2067 6.00664 11.2067 5.74664 11.4667C5.48664 11.7267 5.48664 12.1467 5.74664 12.4067L8.5333 15.1933C8.7933 15.4533 9.2133 15.4533 9.4733 15.1933L16.5266 8.14C16.7866 7.88 16.7866 7.46 16.5266 7.2C16.2666 6.94 15.8466 6.94 15.5866 7.2L8.99997 13.78Z"
          fill="currentColor"
        />
      </g>
    )}
  </SvgIcon>
);
